import { useContext, useEffect, useMemo, useState } from "react";
import KrFormContext, { KrFormContextLandslideType, KrLandslideFormTypes, LandslideRoadCategories, NavHeadingsKROEnum } from "../../../../contexts/krFormContext";
import SelectInput from "../../../../components/shared/selectInput/selectInput";
import { styleFormField, styleFormFieldHalf } from "../../../../components/shared/stylization";
import { GetOptions, prepareDataSingleForSelect } from "../../../../helpers/prepareForSelect";
import { FormFieldProps } from "../../../../components/formField/types/formFieldProps";
import { Option } from "../../../../components/shared/selectInput/types/selectInputProps";
import CheckboxMultiField from "../../../../components/checkboxMultiField/checkboxMultiField";
import FormField from "../../../../components/formField/formField";
import CheckboxField from "../../../../components/checkboxField/checkboxField";
import { FormSectionProps } from "./shared/types/formSectionProps";
import { createConfigValidation, validation } from "../../../../helpers/validation/validation";
import CollectiveSelectField from "../../collectiveEditionView/collectiveField/collectiveSelectField";
import { CollectivePreviewKey } from "../../../../helpers/collective/preview";
import { LabelChipClassType } from "../../../../components/shared/labelChip/types/labelChipProps";

import { getAddCommentBtnDetails, getFieldRef, getItemRef } from "../../../../helpers/form";
import { KROFieldDict } from "../../shared/commentsSidebar/fieldDict";
import { AdditionalIcon } from "../../../../components/shared/additionalIcon/additionalIcon";
import { ReactComponent as addCircle } from '../../../../icons/add_circle.svg';

const LandUse = (props: FormSectionProps) => {

    var { krForm, setkrForm } = useContext(KrFormContext) as KrFormContextLandslideType;
    const isFormNotValid = krForm.config?.isValid !== undefined ? !krForm.config?.isValid : false;
    const [ckeckToggleCheckbox, setCheckToggleCheckbox] = useState(krForm.landslideAttributes?.kolej === 1 ? true : false);
    const [reload, setReload] = useState(false);
    const [errorTipsText, setErrorTipsText] = useState<{[key: string]: string | undefined}>({
        uT_ZAB_MIESZKALNA: '',
        uT_ZAB_GOSPODARCZA: '',
        uT_ZAB_PRZEM_USLUG: '',
        uT_ZAB_UZYT_PUBL: '',
        uT_ZAB_ZABYT_SAKR: '',
        uT_ZAB_INNA: ''
    });
    const [ErrorCheckBox, setErrorCheckBox] = useState<boolean>(false);
    const [ErrorMsg, setErrorMsgCheckBox] = useState<string>('');
    // Validation
    useEffect(() => {
        if (krForm.config?.check && !krForm.config.isValid) {
            const currValidation = createConfigValidation("landUse", false);
            var values: string[] = [];
            values = checkElementsCheckBox(krForm);
            const errorMsg = validation(currValidation, values);
            if (errorMsg !== '') {
                setErrorCheckBox(true);
                setErrorMsgCheckBox(errorMsg);
            }
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [krForm.config?.check])

    const checkElementsCheckBox = (krFormObj: KrLandslideFormTypes) => {
        var values: string[] = [];
        if((krFormObj.landslideAttributes?.uT_LASY === 0 || krFormObj.landslideAttributes?.uT_LASY === null) &&
        (krFormObj.landslideAttributes?.uT_ZAROSLA === 0 || krFormObj.landslideAttributes?.uT_ZAROSLA === null) &&
        (krFormObj.landslideAttributes?.uT_LAKI_PASTWISKA === 0 || krFormObj.landslideAttributes?.uT_LAKI_PASTWISKA === null) &&
        (krFormObj.landslideAttributes?.uT_GRUNTY_ORNE === 0 || krFormObj.landslideAttributes?.uT_GRUNTY_ORNE === null) &&
        (krFormObj.landslideAttributes?.uT_SADY === 0 || krFormObj.landslideAttributes?.uT_SADY === null) &&
        (krFormObj.landslideAttributes?.uT_NIEUZYTKI === 0 || krFormObj.landslideAttributes?.uT_NIEUZYTKI === null)){

        }
        else{
            values.push("Noerror");
        }
        return values;
    }

    useEffect(() => {
        if (krForm.config?.check && !krForm.config.isValid) {
            for (const key of Object.keys(errorTipsText)) {
                setError(key);
            }
            setReload(!reload);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [krForm.config?.check])

    const refreshValidation = (values: string[] | undefined) => {
        const currValidation = createConfigValidation("landUse", false);
        const currValidationMsg = validation(currValidation, values);
        if (currValidationMsg) {
            setErrorCheckBox(true);
            setErrorMsgCheckBox(currValidationMsg);
        } else {
            setErrorCheckBox(false);
            setErrorMsgCheckBox('');
        }
    }

    const setError = (key: string) => {
        const errorMsg = krForm.config?.ValidationError![key];
        if (errorMsg !== '') {
            var newErrorList = {...errorTipsText, [key]: errorMsg};
            setErrorTipsText(newErrorList);
        }
    }

    var slopeCoverageOptions: Option[] = [
        { name: "Lasy", value: "uT_LASY" },
        { name: "Zarośla krzewiaste", value: "uT_ZAROSLA" },
        { name: "Łąki i pastwiska", value: "uT_LAKI_PASTWISKA" },
        { name: "Grunty orne", value: "uT_GRUNTY_ORNE" },
        { name: "Sady", value: "uT_SADY" },
        { name: "Nieużytki", value: "uT_NIEUZYTKI" },
    ]

    var transimissiLinesOptions: Option[] = [
        { name: "Linie energetyczne", value: "liniE_ENERGETYCZNE" },
        { name: "Linie telefoniczne", value: "liniE_TELEFONICZNE" },
        { name: "Wodociągi", value: "liniE_WODOCIAGI" },
        { name: "Kanalizacja", value: "liniE_KANALIZACJA" },
        { name: "Gazociągi", value: "liniE_GAZOCIAGI" },
        { name: "Inne", value: "liniE_INNE" },
    ]

    var slopeCoverageSelected: string[] = [];

    if (krForm.landslideAttributes?.uT_LASY !== null && krForm.landslideAttributes?.uT_LASY) slopeCoverageSelected.push("uT_LASY");
    if (krForm.landslideAttributes?.uT_ZAROSLA !== null && krForm.landslideAttributes?.uT_ZAROSLA) slopeCoverageSelected.push("uT_ZAROSLA");
    if (krForm.landslideAttributes?.uT_LAKI_PASTWISKA !== null && krForm.landslideAttributes?.uT_LAKI_PASTWISKA) slopeCoverageSelected.push("uT_LAKI_PASTWISKA");
    if (krForm.landslideAttributes?.uT_GRUNTY_ORNE !== null && krForm.landslideAttributes?.uT_GRUNTY_ORNE) slopeCoverageSelected.push("uT_GRUNTY_ORNE");
    if (krForm.landslideAttributes?.uT_SADY !== null && krForm.landslideAttributes?.uT_SADY) slopeCoverageSelected.push("uT_SADY");
    if (krForm.landslideAttributes?.uT_NIEUZYTKI !== null && krForm.landslideAttributes?.uT_NIEUZYTKI) slopeCoverageSelected.push("uT_NIEUZYTKI");

    var transimissiLinesSelected: string[] = useMemo(() => {
        var lines: string[] = [];
        if (krForm.landslideAttributes?.liniE_ENERGETYCZNE) lines.push("liniE_ENERGETYCZNE");
        if (krForm.landslideAttributes?.liniE_TELEFONICZNE) lines.push("liniE_TELEFONICZNE");
        if (krForm.landslideAttributes?.liniE_WODOCIAGI) lines.push("liniE_WODOCIAGI");
        if (krForm.landslideAttributes?.liniE_KANALIZACJA) lines.push("liniE_KANALIZACJA");
        if (krForm.landslideAttributes?.liniE_GAZOCIAGI) lines.push("liniE_GAZOCIAGI");
        if (krForm.landslideAttributes?.liniE_INNE) lines.push("liniE_INNE");
        return lines;
    }, [krForm.landslideAttributes?.liniE_ENERGETYCZNE, krForm.landslideAttributes?.liniE_GAZOCIAGI, krForm.landslideAttributes?.liniE_INNE, krForm.landslideAttributes?.liniE_KANALIZACJA, krForm.landslideAttributes?.liniE_TELEFONICZNE, krForm.landslideAttributes?.liniE_WODOCIAGI]);

    // const onChangeCheckbox = (value: string | number | undefined, checked: boolean) => {
    //     var form: any = Object.assign({}, krForm);
    //     form.landslideAttributes[value as string] = checked ? 0 : 1;
    //     setkrForm(form);
    // }

    const onChangeCheckboxDiff = (value: string | number | undefined, checked: boolean) => {
        var form: any = Object.assign({}, krForm);
        form.landslideAttributes[value as string] = checked ? 1 : 0;
        refreshValidation(checkElementsCheckBox(form));
        setkrForm(form);
    }

    const onChangeCheckboxSingle = (e: any) => {
        var form = Object.assign({}, krForm);
        if (form.landslideAttributes) form.landslideAttributes.kolej = ckeckToggleCheckbox ? 0 : 1;
        setCheckToggleCheckbox(!ckeckToggleCheckbox);
        setkrForm(form);
    }

    const getInputProps = (name: string, KRFieldDict: KROFieldDict, fieldFormName: string, rerender?: boolean): FormFieldProps => {
        return {
            style: styleFormFieldHalf,
            type: "text",
            configValidation: getConfigValidation(name),
            validationError: isFormNotValid,
            disabled: !props.editMode,
            tipText: errorTipsText[name],
            pristine: true,
            reload: rerender,
            addCommentBtn: getAddCommentBtnDetails(props.editMode!, KRFieldDict, fieldFormName, props.setNewCommentFieldDetails!),
            inputRef: (node: any) => {getFieldRef(node, KRFieldDict, props.getMapForComment!)},
            setCommentsFilter: () => { if(props.setCommentsFilter) props.setCommentsFilter(KRFieldDict); },
            isMarkedForCommentFilter: props.markedFieldForCommentFiltering === KRFieldDict,
            inputPlaceholder: "Należy podać liczbę całkowitą dodatnią lub 0"
        }
    }

    const setValue = (value: any, name: string) => {
        var form: any = Object.assign({}, krForm);
        form.landslideAttributes[name] = value;
        setkrForm(form);
    }

    var roadCategoriesDict = GetOptions("KATEGORIA_DROGI", krForm.dictionaries, true);

    const getConfigValidation = (name: string) => {
        return createConfigValidation(name, false, undefined, props.version, props.objectType);
    }

    const RoadsAfterOnChange = (opt: Option[] | undefined) => {
        var form = Object.assign({}, krForm);
        var landslideForm = form as KrLandslideFormTypes;
        if (landslideForm) {
            if (opt) {
                if (landslideForm.roadCategories === null || landslideForm.roadCategories === undefined) landslideForm.roadCategories = [];
                var RoadCategories: LandslideRoadCategories[] = [];
                for (var i = 0; i < opt?.length; i++) {
                    // eslint-disable-next-line no-loop-func
                    var element = landslideForm.roadCategories?.find((option) => {
                        return option.kategoriA_DROGI_SID === opt[i].value
                    });
                    if (element) {
                        RoadCategories.push(element);
                    } else {
                        RoadCategories.push({
                            osuwiskO_GID: landslideForm.landslideAttributes?.globalid,
                            kategoriA_DROGI_SID: opt[i].value as number
                        })
                    }
                }
                landslideForm.roadCategories = RoadCategories;
            }
            else {
                landslideForm.roadCategories = [];
            }
            setkrForm(landslideForm);
        }
    }

    const getAddCommentBtn = (KRFieldDict: KROFieldDict, filedName: string) => {
        return getAddCommentBtnDetails(props.editMode!, KRFieldDict, filedName, props.setNewCommentFieldDetails!);
    }

    if (props.collectiveEdition) {
        return (
            <>
                <h2 style={{ width: '100%' }}>9. Użytkowanie terenu w obrębie osuwiska</h2>
                <h3 style={{ width: '100%' }}>Linie przesyłowe</h3>
                <CollectiveSelectField top={true} value={transimissiLinesSelected} isAuto={false} title={"Linie przesyłowe"}
                    forms={props.forms} keyName={CollectivePreviewKey.liniePrzesylowe} actions={props.actions} single={false}
                    setActions={props.setActions} onDelete={props.onDelete} dic={transimissiLinesOptions} labelClass={LabelChipClassType.Checkbox}>
                    <CheckboxMultiField onChange={onChangeCheckboxDiff} checkboxOptions={transimissiLinesOptions}
                        selectedValues={transimissiLinesSelected} labelName='' />
                </CollectiveSelectField>
            </>
        )
    }

    return (
        <>
            <h2 ref={(node) => getItemRef(node, NavHeadingsKROEnum.LandUse, props.getMapForNavScroll!)} style={{ width: '100%' }}>9. Użytkowanie terenu w obrębie osuwiska</h2>           
            <div style={{position: "relative", width: "100%"}} 
                ref={(node: any) => {getFieldRef(node, KROFieldDict.uzytTer_pokrycieStoku, props.getMapForComment!)}}
                onClick={() => { if(props.setCommentsFilter) props.setCommentsFilter(KROFieldDict.uzytTer_pokrycieStoku); }}
            >
                <h3>Pokrycie stoku</h3>
                <CheckboxMultiField disableAllElements={!props.editMode} onChange={onChangeCheckboxDiff} checkboxOptions={slopeCoverageOptions}
                    selectedValues={slopeCoverageSelected} error={ErrorCheckBox} errorMsg={ErrorMsg} />
                {!props.editMode && 
                    <div 
                        className={`addCommentBtnWrapperRegular addCommentBtnWrapper ${props.markedFieldForCommentFiltering === KROFieldDict.uzytTer_pokrycieStoku ? "activeAddCommentBtn" : ""}`} 
                        onClick={getAddCommentBtn(KROFieldDict.uzytTer_pokrycieStoku, "Pokrycie stoku").onClick}>
                        {AdditionalIcon(addCircle)}
                    </div>
                }
            </div>
            <h3 style={{ width: '100%' }}>Zabudowa</h3>
            <FormField {...getInputProps("uT_ZAB_MIESZKALNA", KROFieldDict.uzytTer_zabud_mieszkalna, "Mieszkalna", reload)} labelName="Mieszkalna" setValue={(value) => { setValue(value, "uT_ZAB_MIESZKALNA") }}
                value={krForm.landslideAttributes?.uT_ZAB_MIESZKALNA}
                onlyDigits={true} min={0} />
            <FormField {...getInputProps("uT_ZAB_GOSPODARCZA", KROFieldDict.uzytTer_zabud_godpodarcza, "Gospodarcza", reload)} labelName="Gospodarcza" setValue={(value) => { setValue(value, "uT_ZAB_GOSPODARCZA") }}
                value={krForm.landslideAttributes?.uT_ZAB_GOSPODARCZA} onlyDigits={true} min={0} />
            <FormField {...getInputProps("uT_ZAB_PRZEM_USLUG", KROFieldDict.uzytTer_zabud_przemyslowaUslugowa, "Przemysłowa/usługowa", reload)} labelName="Przemysłowa/usługowa" setValue={(value) => { setValue(value, "uT_ZAB_PRZEM_USLUG") }}
                value={krForm.landslideAttributes?.uT_ZAB_PRZEM_USLUG} onlyDigits={true} min={0} />
            <FormField {...getInputProps("uT_ZAB_UZYT_PUBL", KROFieldDict.uzytTer_zabud_uzytecznosciPublicznej, "Użyteczności publicznej", reload)} labelName="Użyteczności publicznej" setValue={(value) => { setValue(value, "uT_ZAB_UZYT_PUBL") }}
                value={krForm.landslideAttributes?.uT_ZAB_UZYT_PUBL} onlyDigits={true} min={0} />
            <FormField {...getInputProps("uT_ZAB_ZABYT_SAKR", KROFieldDict.uzytTer_zabud_zabytkowaSakralna, "Zabytkowa/sakralna", reload)} labelName="Zabytkowa/sakralna" setValue={(value) => { setValue(value, "uT_ZAB_ZABYT_SAKR") }}
                value={krForm.landslideAttributes?.uT_ZAB_ZABYT_SAKR} onlyDigits={true} min={0} />
            <FormField {...getInputProps("uT_ZAB_INNA", KROFieldDict.uzytTer_zabud_inna, "Inna - Zabudowa", reload)} labelName="Inna" setValue={(value) => { setValue(value, "uT_ZAB_INNA") }}
                value={krForm.landslideAttributes?.uT_ZAB_INNA} inputPlaceholder="Dodaj opis" />
            <h3 style={{ width: '100%' }}>Infrastruktura komunikacyjna</h3>
            <SelectInput 
                style={styleFormField} 
                label="Drogi" 
                onChange={(opt: Option[] | undefined) => {RoadsAfterOnChange(opt)}}
                hasInputTags={true} 
                options={roadCategoriesDict} 
                onlySingleTag={false} 
                configValidation={getConfigValidation("onlyRequired")} 
                selectedOptions={prepareDataSingleForSelect(roadCategoriesDict, krForm.roadCategories?.map((value) => {
                    return value.kategoriA_DROGI_SID;
                }), undefined)}
                pristine={true}
                disabled={!props.editMode}
                addCommentBtn={getAddCommentBtnDetails(props.editMode!, KROFieldDict.uzytTer_infrKom_drogi, "Drogi", props.setNewCommentFieldDetails!)}
                selectRef={(node: any) => {getFieldRef(node, KROFieldDict.uzytTer_infrKom_drogi, props.getMapForComment!)}} 
                setCommentsFilter={() => { if(props.setCommentsFilter) props.setCommentsFilter(KROFieldDict.uzytTer_infrKom_drogi); }}
                isMarkedForCommentFilter={props.markedFieldForCommentFiltering === KROFieldDict.uzytTer_infrKom_drogi}
                validationError={isFormNotValid}
                />
            <div style={{position: "relative", width: "100%", marginTop: "10px", marginBottom: "10px"}} 
                ref={(node: any) => {getFieldRef(node, KROFieldDict.uzytTer_infrKom_linieKolejowe, props.getMapForComment!)}}
                onClick={() => { if(props.setCommentsFilter) props.setCommentsFilter(KROFieldDict.uzytTer_infrKom_linieKolejowe); }}
            >
                <CheckboxField disabled={!props.editMode} style={styleFormField} labelName="Linie kolejowe" value={"kolej"} 
                    inputChecked={ckeckToggleCheckbox} checkmarkSmall={true} onChange={onChangeCheckboxSingle} />
                {!props.editMode && 
                    <div 
                        className={`addCommentBtnWrapperRegular addCommentBtnWrapper ${props.markedFieldForCommentFiltering === KROFieldDict.uzytTer_infrKom_linieKolejowe ? "activeAddCommentBtn" : ""}`} 
                        onClick={getAddCommentBtn(KROFieldDict.uzytTer_infrKom_linieKolejowe, "Linie kolejowe").onClick}>
                        {AdditionalIcon(addCircle)}
                    </div>
                }
            </div>
            
            <div style={{position: "relative", width: "100%"}} 
                ref={(node: any) => {getFieldRef(node, KROFieldDict.uzytTer_liniePrzesylowe, props.getMapForComment!)}}
                onClick={() => { if(props.setCommentsFilter) props.setCommentsFilter(KROFieldDict.uzytTer_liniePrzesylowe); }}
            >
                <h3 style={{ width: '100%' }}>Linie przesyłowe</h3>
                <CheckboxMultiField disableAllElements={!props.editMode} onChange={onChangeCheckboxDiff} checkboxOptions={transimissiLinesOptions}
                    selectedValues={transimissiLinesSelected} />
                {!props.editMode && 
                    <div 
                        className={`addCommentBtnWrapperRegular addCommentBtnWrapper ${props.markedFieldForCommentFiltering === KROFieldDict.uzytTer_liniePrzesylowe ? "activeAddCommentBtn" : ""}`} 
                        onClick={getAddCommentBtn(KROFieldDict.uzytTer_liniePrzesylowe, "Linie przesyłowe").onClick}>
                        {AdditionalIcon(addCircle)}
                    </div>
                }
            </div>
        </>
    )
}

export default LandUse;
